export default __webpack_public_path__ + "static/media/cat5-6.d4113456.jpg";